import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type {
  APIResponse,
  FirmPhone,
  FirmVirtualBusinessCard,
} from "@/lib/types";
import { baseFastApiFirmRoute } from "./firm";

export const retrieveFirmVirtualBusinessCardsV1 = () => {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<FirmVirtualBusinessCard[]>
    >(`${baseFastApiFirmRoute}/virtual-business-cards`)
    .then((res) => res.data);
};

export const createFirmVirtualBusinessCardV1 = (
  data: Pick<FirmVirtualBusinessCard, "fullName"> &
    Partial<
      Pick<
        FirmVirtualBusinessCard,
        | "city"
        | "country"
        | "email"
        | "state"
        | "street1"
        | "street2"
        | "website"
        | "zipCode"
      >
    > & {
      phoneId: FirmPhone["id"];
    },
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<FirmVirtualBusinessCard>
    >(`${baseFastApiFirmRoute}/virtual-business-cards`, data)
    .then((res) => res.data);
};

export const deleteFirmVirtualBusinessCardV1 = (
  data: Pick<FirmVirtualBusinessCard, "id">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<FirmVirtualBusinessCard>
    >(`${baseFastApiFirmRoute}/virtual-business-cards/${id}`)
    .then((res) => res.data);
};
